"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MegaMenuPhrasesSchema = exports.MegaMenuCategoriesSchema = void 0;

var _zod = require("zod");

/**
 * Zod schema for CategoryLite runtime validation.
 * Ensures backend data matches TypeScript CategoryLite expectations.
 *
 * Key validations:
 * - Requires 'visibleTopicsCount' (not legacy 'topicCount')
 * - Excludes performance-heavy fields (description, thumbnailImage, SEO metadata, etc.)
 * - Validates recursive 'children' structure
 *
 * ⚠️ Only include fields that mega-menu actually uses to minimize SSR payload
 */
var CategoryLiteSchema = _zod.z.lazy(function () {
  return _zod.z.object({
    id: _zod.z.number(),
    title: _zod.z.string(),
    parentId: _zod.z.number().nullable(),
    isContainer: _zod.z.boolean(),
    // ✅ visibleTopicsCount is required for displaying topic counts
    visibleTopicsCount: _zod.z.number(),
    url: _zod.z.string(),
    // Recursive children validation
    children: _zod.z.array(_zod.z.lazy(function () {
      return CategoryLiteSchema;
    }))
  }).strict();
} // ❌ Reject any fields not explicitly listed above
);
/**
 * Schema for mega-menu categories prop
 */


var MegaMenuCategoriesSchema = _zod.z.array(CategoryLiteSchema);
/**
 * Schema for mega-menu phrases SSR hydration (GE-232955)
 * Pre-loaded phrases to avoid batch requests and improve TBT/FCP metrics
 */


exports.MegaMenuCategoriesSchema = MegaMenuCategoriesSchema;

var MegaMenuPhrasesSchema = _zod.z.object({
  Common: _zod.z.record(_zod.z.string(), _zod.z.string()),
  Forum: _zod.z.record(_zod.z.string(), _zod.z.string())
});

exports.MegaMenuPhrasesSchema = MegaMenuPhrasesSchema;